import axios from 'axios';
import { API_CONFIGS, AXIOS_CONFIG_STATS } from '../configs';
import { ACTIONS } from './index';

export function getTotalPrivateLinks(postId) {
    const axiosInstance = axios.create(AXIOS_CONFIG_STATS());
    const request = axiosInstance.get(API_CONFIGS.PRIVATE_SUMMARY(postId));

    return {
        type: ACTIONS.PRIVATE_SUMMARY,
        payload: request
    }
}

